import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

const DETAIL_FIELDS = [
  { label: 'Personnel Id', value: 'personnelId' },
  { label: 'Date of Birth', value: 'birthDate' },
  { label: 'Place of Birth', value: 'placeOfBirth' },
  { label: 'NDA Date', value: 'ndaDate' },
  { label: 'Eligibility Date', value: 'eligibilityDate' },
  { label: 'Investigation Type', value: 'investigationType' },
  { label: 'Investigation Open Date', value: 'investigationOpenDate' },
  { label: 'Investigation Close Date', value: 'investigationCloseDate' },
  { label: 'Investigation Status', value: 'investigationStatus' },
  { label: 'Reinvestigation Date', value: 'reinvestigationDate' },
  { label: 'CE Status', value: 'ceStatus' },
  { label: 'CE Enrolled', value: 'ceEnrolled' },
  { label: 'DTMN', value: 'dtmn' }
];

function DetailPanelContent ({ row }) {
  if (!row) return null;

  return (
    <Box
      sx={{
        backgroundColor: 'grey.200', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, paddingY: 2, paddingX: '5%'
      }}
      display='flex'
      flexWrap='wrap'
      justifyContent='space-between'
      spacing={1}
    >
      {DETAIL_FIELDS.map((field) => (
        <Box key={field.label} display='flex'>
          <Typography variant='body2' fontWeight='bold' sx={{ width: '150px', lineHeight: 1 }}>{field.label}:</Typography>
          <Typography variant='body1' sx={{ lineHeight: 1 }}>{row[field.value] ?? 'N/A'}</Typography>
        </Box>
      ))}
    </Box>
  );
}

DetailPanelContent.propTypes = {
  row: PropTypes.shape({
    personnelId: PropTypes.number,
    birthDate: PropTypes.string,
    placeOfBirth: PropTypes.string,
    ndaDate: PropTypes.string,
    eligibilityDate: PropTypes.string,
    investigationType: PropTypes.string,
    investigationOpenDate: PropTypes.string,
    investigationCloseDate: PropTypes.string,
    investigationStatus: PropTypes.string,
    reinvestigationDate: PropTypes.string,
    ceStatus: PropTypes.string,
    ceEnrolled: PropTypes.string,
    dtmn: PropTypes.string
  }).isRequired
};

export default DetailPanelContent;
